import { useContext, useEffect, useState, type RefCallback } from 'react';

import { AgentSessionPollingContext } from './AgentSessionPollingProvider.tsx';
import { pollCommentAgentSessions } from './commentAgentSessionPolling.ts';

export function useCommentAgentSessionPolling(
	enabled: boolean,
	onRequest: Parameters<typeof pollCommentAgentSessions>[2],
): RefCallback<HTMLDivElement> | undefined {
	const scope = useContext(AgentSessionPollingContext);
	const [element, setElement] = useState<HTMLDivElement | null>(null);

	useEffect(() => {
		if (!enabled || !scope || !element) return;
		let stopPolling: (() => void) | undefined;
		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting && !stopPolling) {
				stopPolling = pollCommentAgentSessions(scope.environment, scope.pageId, onRequest);
			} else if (!entry.isIntersecting) {
				stopPolling?.();
				stopPolling = undefined;
			}
		});
		observer.observe(element);
		return () => {
			observer.disconnect();
			stopPolling?.();
		};
	}, [enabled, scope, element, onRequest]);

	return enabled && scope ? setElement : undefined;
}
